import { ChangeDetectionStrategy, Component, computed, effect, input, output, signal } from '@angular/core';

import { SpaceType } from '../../../models/spaces';
import { LocationSelectorComponent, SpaceSelectorComponent } from '../../selectors';

interface FormValue {
  floorId?: string;
  locationId?: string;
  roomId?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LocationSelectorComponent,
    SpaceSelectorComponent,
  ],
  selector: 'avs-li-location-options',
  standalone: true,
  templateUrl: './location-options.component.html',
})
export class LocationOptionsComponent {
  allRequired = input<boolean>(true);
  config = input<FormValue | null>();
  type = input.required<'room' | 'floor' | 'building'>();
  cssSelectorClass = input<string>();
  changed = output<Partial<FormValue> | null>();

  protected eSpaceType = SpaceType;
  protected form = signal<FormValue>({});

  protected isValid = computed(() => {
    const type = this.type();

    if (type === 'room' && this.allRequired()) {
      return this.form().locationId !== undefined &&
        this.form().floorId !== undefined &&
        this.form().roomId !== undefined;
    }

    if (type === 'floor' && this.allRequired()) {
      return this.form().locationId !== undefined &&
        this.form().floorId !== undefined;
    }

    return this.form().locationId !== undefined;
  });

  constructor() {
    const initialEffect = effect(
      () => {
        this.form.set(this.config() ?? {});
        initialEffect.destroy();
      },
      { manualCleanup: true },
    );
  }

  protected patchForm(value: Partial<FormValue>) {
    this.form.set({ ...this.form(), ...value });

    this.changed.emit(this.isValid() ? this.form() : null);
  }

  protected patchLocationForm(form: Partial<FormValue> | null) {
    this.form.set({});
    this.patchForm(form ?? {});
  }
}
